// extracted by mini-css-extract-plugin
export default {"starContainer":"StarEffect_starContainer__mjxeR","star":"StarEffect_star__LHcMb"};